import { Component, Inject } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export interface Product {
    id: number;
    name: string;
    financing: {
        min: number;
        max: number;
    };
    processing: number;
    tenure: number;
    interest: number;
}

@Component({
    selector: 'app-product-detail-modal',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        DecimalPipe,
    ],
    templateUrl: './product-detail-modal.component.html',
    styleUrl: './product-detail-modal.component.scss',
})
export class ProductDetailModalComponent {
    currentPage = 1;
    productsPerPage = 3;
    visibleProducts: any[] = [];
    hasMoreProducts = false;
    ga_event: any;

    constructor(
        public dialogRef: MatDialogRef<ProductDetailModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.updateVisibleProducts();
    }

    ngOnInit(){
        this.ga_event = [{
                calculateFinancing: {
                  id: this.data.showBanks ? 'calculate_my_financing_button_msmefinancing_popup_click' : 'calculate_my_financing_button_dgp_popup_click',
                },
                checkEligibility:{
                  id: this.data.showBanks ? '_check_eligibility_button_msmefinancing_popup_click' : '_check_eligibility_button_dgp_popup_click',
                },
                showMoreProducts:{
                  id: this.data.showBanks ? 'show_more_products_button_msmefinancing_popup_click' : 'show_more_products_button_dgp_popup_click',
                },
                close:{
                  id: this.data.showBanks ? 'x_button_msmefinancing_popup_click' : 'x_button_dgp_popup_click',
                },
                category: this.data.showBanks ? 'MSME Financing Popup Button': 'Digital Guarantee Popup Button',
        }];
    }

    getImgUrl(img: string): string {
        if (img) {
            return img;
        }
        return this.data.selectedLanguage === 'bm'
            ? '/assets/images/image_not_available_bm.webp'
            : '/assets/images/image_not_available_en.webp';
    }

    closeDialog(): void {
        this.dialogRef.close({ dialogClosed: true });
    }

    getUnitFromValidation(validationString: string): string {
        if (!validationString) {
            return 'YEARS';
        }
        const validation = JSON.parse(validationString);
        return validation?.tenure?.unit?.toUpperCase();
    }

    toggleShowMore(): void {
        this.currentPage++;
        this.updateVisibleProducts();
    }

    updateVisibleProducts(): void {
        const startIndex = 0;
        const endIndex = this.currentPage * this.productsPerPage;

        this.visibleProducts = this.data.bankDetails.products.slice(
            startIndex,
            endIndex
        );
        this.hasMoreProducts = endIndex < this.data.bankDetails.products.length;
    }

    calculateFinancing(): void {
        this.dialogRef.close({isCalculatorClick: true});
    }

    onClickEligibility(prodCode) {
        this.dialogRef.close({
            isCheckMatchingProducts: true,
            prodCode
        });
    }
}
